import { type VariantProps, cva } from "class-variance-authority";
import * as React from "react";

import { cn } from "@punto/ui/lib/utils";

const alertVariants = cva(
  "relative w-full rounded-md border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
  {
    variants: {
      variant: {
        // Measured on Figma alert frame 152:2375: Light-step fill with a
        // full-strength Base-step 1px border. See spec §9.2.
        default: "border-border bg-background text-foreground",
        destructiveFilled:
          "border-destructive-base bg-destructive-light text-destructive [&>svg]:text-destructive",
        destructive:
          "border-destructive-base text-destructive [&>svg]:text-destructive",
        warning:
          "border-warning-base bg-warning-light text-warning [&>svg]:text-warning",
        info: "border-info-base bg-info-light text-info [&>svg]:text-info",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

const Alert = ({
  className,
  variant,
  ...props
}: React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof alertVariants>) => (
  <div
    role="alert"
    className={cn(alertVariants({ variant }), className)}
    {...props}
  />
);
Alert.displayName = "Alert";

const AlertTitle = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h5
    className={cn("mb-1 font-medium leading-none tracking-tight", className)}
    {...props}
  />
);
AlertTitle.displayName = "AlertTitle";

const AlertDescription = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) => (
  <div className={cn("text-sm [&_p]:leading-relaxed", className)} {...props} />
);
AlertDescription.displayName = "AlertDescription";

export { Alert, AlertTitle, AlertDescription };
